import { CartItem } from './cart/cart-item.js';
import { Download } from './download/download.js';
import { LocationService } from './location/location.service.js';
import { MenuItem } from './menu/menu-item.js';
import { Metadata } from './meta/metadata.js';
import { SwitchItem } from './switch-item/switch-item.js';
import { ThumbnailGeneratorComponent } from './thumbnail/thumbnail-generator';

export class ConfiguratorUI {

	get configurables() {
		return this.viewDescription ? this.viewDescription.productConfigurables : [];
	}

	get validConfigurations() {
		return this.viewDescription ? this.viewDescription.validConfigurations : [];
	}

	get clientInfo() {
		return this.viewDescription ? this.viewDescription.clientInfo : {};
	}

	get state() {
		return this.viewDescription ? this.viewDescription.productState : {};
	}

	get clientCode() {
		return this.viewDescription ? this.viewDescription.clientCode : null;
	}

	constructor(node, productData, configurator) {
		this.node = node;
		this.productData = productData;
		this.configurator = configurator;
		this.onSelected = this.onSelected.bind(this);
		this.checkMenuValidSelection = this.checkMenuValidSelection.bind(this);
		// console.log('ConfiguratorUI', this.configurator.controller.model.version);
		// console.log('ConfiguratorUI', this.configurator);
	}

	setViewDescription(viewDescription) {
		if (viewDescription) {
			this.viewDescription = Object.assign({}, viewDescription);
			Object.keys(this.viewDescription).forEach(key => {
				const value = this.viewDescription[key];
				if (Array.isArray(value)) {
					this.viewDescription[key] = this.viewDescription[key].slice();
				} else if (typeof value === 'object') {
					this.viewDescription[key] = Object.assign({}, this.viewDescription[key]);
				}
			});
		} else {
			this.viewDescription = null;
		}
	}

	init() {
		const configurables = this.configurables;
		if (configurables.length > 0) {
			for (const c of configurables) {
				if (!c.hidden) {
					if (c.options.length > 0) {
						const option = {
							value: c.selection,
							ID: c.ID,
							options: {},
						};
						for (const o of c.options) {
							option.options[o] = o;
						}
						// console.log('ConfiguratorUI.init.option select', option);
					} else {
						// for configurables with free value (text)
						const option = {
							value: c.selection,
							ID: c.ID,
						};
						// console.log('ConfiguratorUI.init.option text', option);
					}
				}
			}
		}
		this.update(this.viewDescription);
		setTimeout(x => {
			this.addSwitch();
		}, 3000);
		window.getBase64Thumb = this.getBase64Thumb.bind(this);
		this.setGenerator();
		this.restyleConfigurator();
	}

	update(viewDescription) {
		this.viewDescription = viewDescription;
		const clientCode = this.clientCode;
		let productCode = null;
		if (clientCode != null) {
			productCode = clientCode.replace(/_/g, ' ');
		}
		this.currentCode = clientCode;
		if (!this.menu) {
			this.getVariants();
			this.dataMap();
			this.addMenu();
		} else {
			this.updateMenu();
		}
		if (clientCode) {
			if (!this.cart) {
				this.addCart();
			}
			if (!this.download) {
				this.addDownload();
			}
			if (!this.metadata) {
				this.addMetadata();
				//this.addMetadataFooter();
			}
			this.cart.setPriceByCode(clientCode);
			LocationService.set('c', escape(clientCode));
			this.metadata.update(clientCode);
		}
		// console.log('ConfiguratorUI.update', 'viewDescription', viewDescription, 'productCode', productCode, 'currentCode', this.currentCode);
	}

	changeState(selection) {
		const state = this.state;
		state.selection = selection;
		const viewDescription = this.configurator.changeProductState(selection);
		// console.log('ConfiguratorUI.changeState', selection, viewDescription);
		if (viewDescription != undefined) {
			this.update(viewDescription, false);
		}
	}

	changeConfigurables(option) {
		let viewDescription;
		let configurables = this.configurables; // .slice().map(x => Object.assign({}, x));
		const configurable = configurables.find(x => x.ID === option.ID);
		// console.log('ConfiguratorUI.changeConfigurables configurable', configurable, option.ID);
		if (configurable) {
			const previousSelection = configurable.selection;
			configurable.selection = option.value;
			if (!this.isValidComposition(configurables)) {
				configurable.selection = previousSelection;
				configurables = this.getFirstValidComposition(option.ID, option.value, configurables);
				// console.log('ConfiguratorUI.changeConfigurables !isValidComposition', configurables);
			}
			if (configurables) {
				viewDescription = this.configurator.changeProductConfiguration(configurables);
			}
		}
		if (viewDescription != undefined) {
			this.update(viewDescription);
		}
		// console.log('ConfiguratorUI.changeConfigurables', 'viewDescription', viewDescription);
	}

	isValidComposition(configurables) {
		const configurationMap = this.getConfigurationMap();
		// console.log('ConfiguratorUI.isValidComposition !!!', configurationMap);
		const configuration = configurationMap.find((c) => {
			const match = configurables.reduce((p, i) => {
				// console.log(i.ID, c[i.ID], i.selection);
				return p && (c[i.ID] === i.selection);
			}, true);
			return match;
		});
		// console.log('ConfiguratorUI.isValidComposition', configuration, configurables);
		return configuration;
	}

	getBase64Thumb() {
		return new Promise((resolve, reject) => {
			try {
				const state = this.state;
				const screen = this.configurator.getProductConfigurationImage(state.selection, 435, 320, 'image/jpeg');
				// console.log('ConfiguratorUI.getBase64Thumb', screen);
				resolve(screen.replace('data:image/jpeg;base64,', ''));
			} catch (error) {
				reject(error);
			}
		});
	}

	// custom

	getVariants() {
		const clientInfo = this.clientInfo;
		const variants = clientInfo.filter(x => x.configurableID === 'variant');
		const dataVariant = this.productData.items.filter(x => x.type === 'variant');
		dataVariant.forEach(data => {
			let items = [];
			variants.forEach(variant => {
				if (variant.clientInfo.parteCodice === data.clientInfo) {
					// console.log('parteCodice', variant.clientInfo.parteCodice, data.clientInfo);
					items.push(variant);
				}
			});
			data.items = items.map(x => {
				return {
					clientInfo: data.clientInfo,
					name: data.label,
					type: 'option-variant',
					configurableID: x.configurableID,
					selection: x.selection,
				};
			});
		});
	}

	dataMap() {
		const validConfigurations = this.validConfigurations;
		const clientInfo = this.clientInfo;
		// console.log('clientInfo', clientInfo);
		if (productSheet.typeDB === 'divcal') {
			clientInfo.forEach(data => {
				const codePart = Object.keys(data.clientInfo)[0];
				data.clientInfo = {
					parteCodice: codePart,
					materialeCodice: data.clientInfo[codePart]
				};
			});
		}
		if (productSheet.typeDB === 'divd3') {
			clientInfo.forEach(data => {
				// console.log(data.configurableID);
				let parteCodice;
				switch (data.configurableID) {
					case 'combinazione':
						parteCodice = 'combinazioniCodice';
						break;
					case 'piedino':
						parteCodice = 'piedinoCodice';
						break;
					case 'piedini':
						parteCodice = 'piedinoCodice';
						break;
					case 'tipo-piede':
						parteCodice = 'valueCodice';
						break;
					case 'rivestimento':
						parteCodice = 'rivestimentiCodice';
						break;
					case 'variant':
						parteCodice = 'combinazioniCodice';
						break;
				}
				/*
				piedino
				tipo-piede
				rivestimento
				variant
				*/
				data.clientInfo = {
					parteCodice: parteCodice,
					materialeCodice: data.clientInfo[parteCodice],
				};
			});
		}
		// console.log('ConfiguratorUI.dataMap', 'translatorData', clientInfo, 'productData', this.productData, 'currentCode', this.currentCode);
		// const checkCode = 'KAL7S8P';
		// const checkCode = '0S8C';
		const checkCode = null;
		if (checkCode) {
			console.log(validConfigurations);
			console.log('ConfiguratorUI.dataMap.clientInfo', clientInfo.filter(x => x.clientInfo.materialeCodice === checkCode));
			console.log('ConfiguratorUI.dataMap.validConfigurations', validConfigurations.filter(x => x.configurables[1].clientInfo.valueCodice && x.configurables[1].clientInfo.valueCodice === checkCode));
		}
		this.productData.items.forEach(menu => {
			menu.items.forEach(part => {
				if (part.items) {
					part.items.forEach(option => {
						const parteCodice = option.clientInfo.parteCodice;
						const materialeCodice = option.clientInfo.materialeCodice;
						const finituraCodice = option.clientInfo.finituraCodice;
						const versioneCodice = option.clientInfo.versioneCodice;
						let validConfiguration = validConfigurations.find(x => {
							// const clientCode = x.clientCode;
							const configurables = x.configurables;
							const configurable = configurables.find(c => {
								if (productSheet.typeDB === 'artcal') {
									return c.clientInfo && c.clientInfo.parteCodice === parteCodice &&
										c.clientInfo.materialeCodice === materialeCodice &&
										c.clientInfo.finituraCodice === finituraCodice;
								} else {
									return c.clientInfo && c.clientInfo[parteCodice] === materialeCodice;
								}
							});
							if (checkCode && configurable != null && x.clientCode.indexOf(checkCode) !== -1) {
								console.log('ConfiguratorUI.dataMap.checkCode', checkCode, parteCodice, materialeCodice, finituraCodice, versioneCodice, configurable.ID, configurable.selection, x);
							}
							if (configurable != null) {
								option.configurableID = menu.configurableID = configurable.ID;
								option.selection = configurable.selection;
								menu.versioneCodice = versioneCodice;
								return true;
							} else {
								return false;
							}
						});
						if (!validConfiguration) {
							option.configurableID = null;
							if (checkCode) {
								// console.log('ConfiguratorUI.dataMap.notfound', option, menu);
								console.log('ConfiguratorUI.dataMap.notfound', parteCodice, materialeCodice, finituraCodice, versioneCodice);
								/*
								console.log('ConfiguratorUI.dataMap.notfound', parteCodice, materialeCodice, versioneCodice,
									validConfigurations
										.map(x => {
											const configurables = x.configurables.filter(c => {
												return c.clientInfo[parteCodice] != null;
											});
											return configurables;
										})
										.filter(x => x.length > 0)
										.map(x => x.clientInfo[parteCodice])
								);
								*/
							}
						}
						return;
						// availableConfigurations
						let clientId = clientInfo.find(x => {
							let clientInfoCode;
							if (x.clientInfo) {
								switch (productSheet.typeDB) {
									case 'artcal':
										clientInfoCode = x.clientInfo.parteCodice + '|' + x.clientInfo.materialeCodice + '|' + x.clientInfo.finituraCodice;
										break;
									case 'divcal':
										clientInfoCode = x.clientInfo.parteCodice + '|' + x.clientInfo.materialeCodice;
										break;
									case 'divd3':
										clientInfoCode = x.clientInfo.parteCodice + '|' + x.clientInfo.materialeCodice;
										break;
								}
							}
							x.clientInfoCode = clientInfoCode;
							/*
							if (checkCode) {
								if (clientInfoCode.indexOf(checkCode) !== -1 || option.clientInfo.id.indexOf(checkCode) !== -1) {
									console.log('ConfiguratorUI.dataMap', clientInfoCode, option.clientInfo.id, x.clientInfo);
								}
								// id: "rivestimentiCodice|KAL7S8P"
								// materialeCodice: "KAL7S8P"
								// parteCodice: "rivestimentiCodice"
							}
							*/
							// console.log(x.configurableID, x.selection);
							const match = clientInfoCode === option.clientInfo.id;
							// console.log('ConfiguratorUI.', clientInfoCode, option.clientInfo.id, match);
							return match;
						});
						if (clientId) {
							// console.log('clientId', clientId);
							option.configurableID = menu.configurableID = clientId.configurableID;
							option.selection = clientId.selection;
							menu.versioneCodice = option.versioneCodice;
						} else {
							option.configurableID = null;
							// console.log('ConfiguratorUI.dataMap.notfound', option, menu);
						}
					});
					part.items = part.items.filter(x => x.configurableID !== null);
				}
			});
			menu.items = menu.items.filter(x => x.configurableID === 'variant' || (x.items && x.items.length));
		});
		// se ci sono parti da disabilitare sul menù, elimina il menu di primo livello relativo.
		const disabledParts = this.getDisabledParts();
		this.productData.items = this.productData.items.filter(x => disabledParts.indexOf(x.configurableID) === -1);
	}

	getDisabledParts() {
		const validConfigurations = this.validConfigurations;
		const configurables = this.configurables;
		let filteredConfigurables = [];
		let disableParts = [];
		validConfigurations.forEach(configuration => {
			filteredConfigurables = configuration.configurables.filter((x, index, array) => array.findIndex((t) => {
				return (t.ID === x.ID);
			}) === index);
		});
		filteredConfigurables.forEach(x => {
			x.available = false;
			configurables.forEach(y => {
				if (x.ID === y.ID) {
					x.available = true;
				}
			});
			if (!x.available) {
				disableParts.push(x.ID);
			}
		});
		return disableParts;
	}

	addMenu() {
		let menu = this.menu;
		if (menu) {
			menu.off('selected', this.onSelected);
			if (menu.node.parentNode) {
				menu.node.parentNode.removeChild(menu.node);
			}
			menu.destroy();
			this.menu = null;
		}
		// console.log('ConfiguratorUI.addMenu', this.productData);
		menu = this.menu = new MenuItem(this.productData);
		// console.log('ConfiguratorUI.addMenu', menu);
		// al click delle opzioni del menu, esegue una set selection per cambiare le opzioni del modello 3d
		menu.on('selected', this.onSelected);
		this.node.querySelector('[data-configurator-nav]').insertBefore(menu.node, this.node.querySelector('.conf__cart'));
		this.updateMenu();
	}

	addCart() {
		if (this.cart) {
			if (this.cart.node.parentNode) {
				this.cart.node.parentNode.removeChild(this.cart.node);
			}
			this.cart.destroy();
			this.cart = null;
		}
		const cart = this.cart = new CartItem(this.node.querySelector('.conf__cart'));
		const cartWrapper = this.node.querySelector('[data-configurator-cart]');
		cart.setPriceByCode(this.currentCode);
		if (cartWrapper) {
			cartWrapper.appendChild(cart.node);
		}
	}

	addDownload() {
		const download = this.download = new Download(this.node, this.currentCode);
	}

	addMetadata() {
		const metawrapper = this.node.querySelector('[data-configurator-meta]');
		this.metadata = new Metadata(this.currentCode, metawrapper);
		this.metadata.on('loaded', data => {
			this.download.updateData(this.currentCode, data);
		});
	}

	//addMetadataFooter() {
	//	const metawrapperfooter = this.node.querySelector('[data-configurator-meta-footer]');
	//	this.metadatafooter = new Metadata(this.currentCode, metawrapperfooter);
	//	this.metadatafooter.on('loaded', data => {
	//		this.download.updateData(this.currentCode, data);
	//	});
	//}

	addSwitch() {
		const state = this.state;
		const options = state.options;
		if (!(options[0] === 'aperto' && options[1] === 'chiuso')) {
			return;
		}
		// console.log('ConfiguratorUI.addSwitch', state.selection);
		const switchItem = this.switchItem = new SwitchItem(this.node.querySelector('[data-switch]'));
		switchItem.on('switch', events => {
			const selection = events.open ? options[0] : options[1];
			this.changeState(selection);
		});
	}

	setGenerator() {
		const node = this.node;
		const inspirations = node.querySelector('[data-inspirations]');
		// console.log('ConfiguratorUI.setGenerator inspirations', inspirations);
		if (!inspirations) {
			return;
		}
		const generator = new ThumbnailGeneratorComponent(inspirations.querySelector('[data-thumbnail-generator]'));
		// console.log('ConfiguratorUI.setGenerator generator', generator);
		generator.on('ready', () => {
			const thumbnails = Array.prototype.slice.call(inspirations.querySelectorAll('[data-thumbnail]'));
			const loadThumbnail = () => {
				if (thumbnails.length) {
					setTimeout(() => {
						const node = thumbnails.shift();
						const clientCode = node.getAttribute('data-thumbnail');
						window.thumbnailGeneratorRender(clientCode).then(base64 => {
							node.src = base64;
							loadThumbnail();
						});
					});
				} else {
					generator.destroy();
				}
			};
			loadThumbnail();
			const configureLinks = Array.prototype.slice.call(inspirations.querySelectorAll('[data-configure]')).map((node) => {
				node.addEventListener('click', () => {
					const clientCode = node.getAttribute('data-configure');
					ThumbnailGeneratorComponent.setupCompositionFromClientCode(this, clientCode).then(success => {
						inspirations.classList.remove('opened');
						// console.log('success', success);
					});
				});
			});
			const togglers = Array.prototype.slice.call(node.querySelectorAll('[data-inspire-toggler]')).map(node => {
				node.addEventListener('click', () => {
					if (inspirations.classList.contains('opened')) {
						inspirations.classList.remove('opened');
					} else {
						inspirations.classList.add('opened');
					}
				});
				return node;
			});
		});
	}

	updateMenu() {
		const menu = this.menu;
		const configurables = this.configurables;
		menu.updateMenu(configurables);
		menu.setDisabledStates(this.checkMenuValidSelection);
		this.recalcOptionsHeight();
	}

	checkMenuValidSelection(configurableID, selection) {
		const configurables = this.configurables.filter(x => x.ID !== configurableID);
		let validConfigurations = this.validConfigurations.map(x => x.configurables).filter(x => {
			let has = true;
			configurables.forEach(configurable => {
				const option = x.find(c => c.ID === configurable.ID);
				has = has && option && option.selection === configurable.selection;
			});
			return has;
		});
		const valid = validConfigurations.find(x => {
			const o = x.find(c => c.ID === configurableID && c.selection === selection);
			return o;
		});
		// console.log('checkMenuValidSelection', 'configurableID', configurableID, 'selection', selection, 'valid', valid);
		return valid;
	}

	onSelected(events) {
		if (events.length === 3) {
			this.setSelection(events[2].item.configurableID, events[2].item.selection, events[2].item);
		}
		if (events.length === 2 && events[0].item.type === 'variant') {
			this.setSelection(events[1].item.configurableID, events[1].item.selection, events[1].item);
		}
	}

	recalcOptionsHeight() {
		const menu = this.menu;
		const items = Array.from(menu.node.querySelectorAll('.conf__options>.nav--menu__items,.nav--menu.active>.conf__panel>.nav--menu__item>.nav--menu__items'));
		const height = items.reduce((p, c) => {
			return p + c.getBoundingClientRect().height;
		}, 0);
		// console.log('recalcOptionsHeight', height, items, menu.node.innerHTML);
		const root = document.querySelector(':root');
		root.style.setProperty('--options', `${Math.round(height + 240)}px`);
		window.dispatchEvent(new Event('resize'));
	}

	getFirstValidComposition(key, selection, configurables) {
		/*
		const configuration = this.validConfigurations.find(x => {
			const configurables = x.configurables;
			return configurables.reduce((p, c) => {
				return p || (c.ID === key && c.selection === selection);
			}, false);
		});
		*/
		const configurations = this.validConfigurations.filter(x => {
			const matching = x.configurables.find(c => c.ID === key && c.selection === selection) != null;
			x.score = x.configurables.reduce((p, c) => {
				const m = configurables.find(x => x.ID === c.ID && x.selection === c.selection) != null;
				return p + (m ? 1 : 0);
			}, 0);
			return matching;
		});
		configurations.sort((a, b) => {
			return b.score - a.score;
		});
		if (configurations.length) {
			const configurables = configurations[0].configurables;
			// console.log('ConfiguratorUI.getFirstValidComposition', configurables);
			return configurables;
		} else {
			return undefined;
		}
	}

	setSelection(key, selection, menuItem) {
		this.changeConfigurables({ ID: key, value: selection });
	}

	getConfigurationMap() {
		const validConfigurations = this.validConfigurations;
		const configurationMap = validConfigurations.map(x => {
			const map = {};
			x.configurables.forEach(c => {
				map[c.ID] = c.selection;
			});
			return map;
		});
		return configurationMap;
	}

	resizeObserver() {
		const node = this.node;
		const resizeObserver = new ResizeObserver(entries => {
			if (entries.length) {
				this.recalcOptionsHeight();
				window.dispatchEvent(new Event('resize'));
			}
		});
		resizeObserver.observe(node);
	}

	restyleConfigurator() {

		const self = this;

		self.resizeObserver();

		$('.conf__panel-options').slick({
			variableWidth: true,
			slidesToScroll: 9,
			infinite: false,
			//swipe: false,
			responsive: [
				{
					breakpoint: 1199,
					settings: {
						slidesToScroll: 7
					}
				},
				{
					breakpoint: 991,
					settings: {
						slidesToScroll: 5
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToScroll: 1,
						swipe: true
					}
				}
			]
		});

		function slickFix() {
			const width = $(this).find('.slick-list').width();
			if (width) {
				const count = Math.floor(width / 100);
				const items = $(this).find('.slick-slide').length;
				// console.log('count', count, items);
				// $(this).slick('slickSetOption', 'slidesToScroll', count, true);
				if (items < count) {
					$(this).find('.slick-next').addClass('slick-disabled');
				} else {
					$(this).find('.slick-next').removeClass('slick-disabled');
				}
			}
		}

		$('.conf__panel-options').each(slickFix);

		$(window).resize(function() {
			$('.conf__panel-options').each(slickFix);
		});

		$('.conf__option--parent').each(function() {
			if ($('.conf__panel-content .conf__panel-title', this).length) {
				$(this).addClass('more-tabs');
			}
		});

		/*
		$('.more-tabs').each(function() {
			$('.conf__panel-content:first-child', this).addClass('active');
		});
		*/

		$('.conf__panel-content').not($('.conf__panel-content .ico')).on('click', function() {
			if (!$(this).hasClass('active')) {
				$(this).closest('.nav--menu__items').find('.active').removeClass('active');
				$(this).addClass('active');
			}
			self.recalcOptionsHeight();
			return false;
		});

		$('.conf__panel-title .ico').on('click', function() {
			$('body').addClass('fancy-open');
			return false;
		});

		$('.conf__fancy-content .btn, .conf__fancy-content .conf__fancy-close').on('click', function() {
			$('.conf__fancy.active').removeClass('active');
			$('body').removeClass('fancy-open');
			return false;
		});

		//apertura fake tramite nuovi bottoni
		$('.btn--conf, .conf__footer-ico, .nav--menu.variant').on('click', function() {
			$('body').addClass('conf--open');
			self.menu.openFirstPart();
			self.recalcOptionsHeight();
			/*$('.conf__sidebar .conf__options .nav--menu__items .nav--menu:first-child').addClass('active');*/
			//console.log('fai resize per aprire');
			return false;
		});

		//chiudo il configuratore
		$('.btn-continua').on('click', function() {
			$('body').removeClass('conf--open');
			self.menu.reset();
			//console.log('fai resize per chiudere');
			$('body,html').stop().animate({ scrollTop: $(".conf__sidebar").offset().top - 10 }, 'slow');
			return false;
		});

		//apro pannello annulla
		$('.btn_annulla').on('click', function() {
			$('.conf__cancel').addClass('active');
			return false;
		});

		$('.conf__cancel .btn-primary, .conf__cancel .conf__fancy-close').on('click', function() {
			$('.conf__cancel').removeClass('active');
		});

		$('.conf__cancel .btn-secondary').on('click', function() {
			$('.conf__cancel').removeClass('active');
			$('body').removeClass('conf--open');
			self.menu.reset();
			$('body,html').stop().animate({ scrollTop: $(".conf__sidebar").offset().top - 10 }, 'slow');
			//console.log('fai resize per chiudere da annulla');
		});

		//non faccio vedere gli altri slick all'hover
		/*
		$('.conf__option--parent .h5').hover(function() {
			if (!$(this).closest('.conf__option--parent').hasClass('active')) {
				$(this).closest('.conf__option--parent').find('.nav--menu__items').addClass('hidden');
			}
		}, function() {
			$('.nav--menu__items', this).removeClass('hidden');
		});
		$('.nav--menu.category .conf__panel-title').hover(function() {
			if (!$(this).closest('.conf__panel-content').hasClass('active')) {
				$(this).closest('.conf__panel-content').find('.nav--menu__items').addClass('hidden');
			}
		}, function() {
			$('.nav--menu__items', this).removeClass('hidden');
		});
		$('.conf__option--parent, .nav--menu.category').on('click', function() {
			$('.nav--menu__items', this).removeClass('hidden');
			return false;
		});
		*/

		//non chiudo il configuratore se clicco su elemento già selezionato
		$('.conf__dett').on('click', function() {
			if ($(this).closest('.nav--menu').hasClass('active')) {
				return false;
			}
		});
	}
}
